import { memo } from 'react';
import { Cost as CostIcon } from '@shared/assets/index.ts';
import * as st from './styles.module.scss';

interface Props {
  cost: string;
  isAuthor: boolean;
  is_paid?: boolean;
}

interface CostProps {
  cost: string | number;
}

const Cost: React.FC<CostProps> = ({ cost }) => {
  return (
    <div className={st.wrapper}>
      <CostIcon />
      <p>
        {cost} <span>RUB</span>
      </p>
    </div>
  );
};

export const SmallCardCost: React.FC<Props> = memo(({ cost, is_paid, isAuthor }) => {
  return (
    <div className={st.description}>
      {(!is_paid || (isAuthor && cost !== '0')) && (
        // && program.cost_base !== 0
        <Cost cost={cost} />
      )}
    </div>
  );
});
